;(function() {
  'use strict'

  angular.module('app.core').service('projectSortService', Service)

  // Built once. Constructing a collator per comparison is the classic
  // hot-loop mistake: sorting 100 projects runs several hundred comparisons.
  var collator = new Intl.Collator(undefined, { sensitivity: 'base' })

  /* @ngInject */
  function Service() {
    var self = this

    // The `value` strings are persisted by glPrefs, so they are a contract:
    // renaming one silently resets every user who chose it to the default.
    self.OPTIONS = [
      { value: 'lastUpdated', label: 'Last updated' },
      { value: 'created', label: 'Date created' },
      { value: 'name', label: 'Name A-Z' },
      { value: 'recentResponses', label: 'Recent responses' },
    ]
    self.DEFAULT = 'lastUpdated'
    self.isValid = isValid
    self.sort = sort

    var PROJECT_FIELDS = {
      updated: 'lastSurveyUpdatedAt',
      created: 'createdAt',
      responses: 'lastResponseReceivedAt',
      name: 'name',
    }

    function isValid(value) {
      return _.some(self.OPTIONS, { value: value })
    }

    // Returns a new array; the one passed in is never reordered.
    function sort(items, value, fields) {
      var get = _.mapValues(_.assign({}, PROJECT_FIELDS, fields), _.iteratee)
      var comparator = getComparator(isValid(value) ? value : self.DEFAULT, get)
      return (items || []).slice().sort(comparator)
    }

    // Every comparator ends on `id`, so the order is total: two items that
    // tie on every other key still have one fixed relative order, regardless
    // of engine sort stability or the order they arrived in.
    function getComparator(value, get) {
      switch (value) {
        case 'created':
          return chain([newestFirst(get.created), byId])
        case 'recentResponses':
          return byActivity(get.responses, get)
        case 'name':
          return chain([byName(get.name), byId])
        default:
          return byActivity(get.updated, get)
      }
    }

    function byActivity(getDate, get) {
      return chain([newestFirst(getDate), newestFirst(get.created), byId])
    }

    function chain(fns) {
      return function(a, b) {
        for (var i = 0; i < fns.length; i++) {
          var result = fns[i](a, b)
          if (result) return result
        }
        return 0
      }
    }

    // A missing date sorts after every real one, which is what puts the "no
    // activity" group last.
    function newestFirst(getDate) {
      return function(a, b) {
        var at = toTime(getDate(a))
        var bt = toTime(getDate(b))
        if (!at && !bt) return 0
        if (!at) return 1
        if (!bt) return -1
        return bt - at
      }
    }

    // Dates arrive as moments or, on surveys, ISO strings; subtracting two
    // strings gives NaN, which sort() reads as a tie.
    function toTime(date) {
      return date ? new Date(date).getTime() : null
    }

    function byName(getName) {
      return function(a, b) {
        return collator.compare(getName(a) || '', getName(b) || '')
      }
    }

    function byId(a, b) {
      if (a.id === b.id) return 0
      return a.id < b.id ? -1 : 1
    }
  }
})()
